import { mdiCheck } from '@mdi/js'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import ROUTES from 'app/routes'
import { H1 } from 'components/Typography'

import {
  currentRootDomainIdSelector,
  rootDomainsDataSelector,
} from 'features/rootDomains/selectors'
import {
  CompaniesCurrentIcon,
  CompaniesItemBtn,
  CompaniesItemMeta,
  CompaniesItemsList,
  CompaniesMetaName,
  StyledCompaniesPage,
} from './styles'
import CompanyImage from 'components/Image/CompanyImage'
import { useHistory } from 'react-router-dom'
import { useMemo } from 'react'
import { LOCALSTORAGE_SELECTED_ROOT } from 'features/rootDomains/consts'
import { FormattedMessage } from 'react-intl'
import { selectCompanyMessages } from './messages'
import { selectedNavTopDomainActions } from 'features/domains/slice'

function CompaniesPage() {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const currentRootId = useAppSelector(currentRootDomainIdSelector)
  const rootDomains = useAppSelector(rootDomainsDataSelector.data)

  const sortedByCurrentDomains = useMemo(
    () =>
      rootDomains && rootDomains.length
        ? [...rootDomains].sort((a, b) => {
            if (a.id === currentRootId && b.id !== currentRootId) {
              return -1
            } else if (a.id !== currentRootId && b.id === currentRootId) {
              return 1
            } else {
              return 0
            }
          })
        : [],
    [currentRootId, rootDomains]
  )

  const handleClick = (domainId: string) => {
    dispatch(selectedNavTopDomainActions.clear())
    localStorage.setItem(LOCALSTORAGE_SELECTED_ROOT, domainId)
    history.push(ROUTES.homesJobs(domainId))
  }

  return (
    <StyledCompaniesPage>
      <H1>
        <FormattedMessage {...selectCompanyMessages.title} />
      </H1>
      <CompaniesItemsList>
        {sortedByCurrentDomains.map((domain) => {
          const isCurrentRootDomain = domain.id === currentRootId

          return (
            <CompaniesItemBtn
              key={domain.id}
              $isActive={isCurrentRootDomain}
              onClick={() => handleClick(domain.id)}
            >
              <CompaniesItemMeta>
                {!!domain.imageUrl && <CompanyImage src={domain.imageUrl} />}
                <CompaniesMetaName>{domain.name}</CompaniesMetaName>
              </CompaniesItemMeta>
              {isCurrentRootDomain && (
                <CompaniesCurrentIcon path={mdiCheck} size={1} />
              )}
            </CompaniesItemBtn>
          )
        })}
      </CompaniesItemsList>
    </StyledCompaniesPage>
  )
}

export default CompaniesPage
